import {assign, filter} from 'lodash';
import {useEffect} from 'react';

import RecommendationAnnotationTags from 'components/RecommendationAnnotation/Tags';
import AccIdCell, {baseAccIdColumn} from 'components/Table/Cell/AccId';
import TextFilter from 'components/Table/Filter/Text';
import SimpleTable from 'components/Table/Simple';
import {fixedColumnStyle, flexColumnStyle} from 'components/Table/columnHelpers';
import Tag from 'components/Tag';
import HtmlContainer from 'components/shared/html_container';
import App from 'conf/app';

import './table.scss';

export default function FdaPgxAssociationTable({associations = [], onlyCurrent = true}) {
  const pgxChemicalsColumn = assign(baseAccIdColumn, {Cell: PgxChemicalsCell});
  const columns = [
    {
      id: 'relatedChemicals',
      Header: 'Chemical',
      accessor: 'relatedChemicals',
      ...pgxChemicalsColumn,
      ...fixedColumnStyle(220),
    },
    {
      id: 'relatedGenes',
      Header: 'Gene',
      accessor: 'relatedGenes',
      ...baseAccIdColumn,
      ...fixedColumnStyle(180),
    },
    {
      id: 'affectedSubgroup',
      Header: 'Affected Subgroups',
      accessor: 'affectedSubgroup',
      sortable: true,
      Filter: TextFilter,
      ...fixedColumnStyle(250),
    },
    {
      id: 'summary',
      Header: 'Description of Gene-Drug Interaction',
      accessor: 'summaryMarkdown',
      Cell: SummaryCell,
      Filter: TextFilter,
      ...flexColumnStyle({width: 600, grow: 6}),
    },
    {
      id: 'versionDate',
      Header: 'FDA Content Date',
      accessor: 'versionDate',
      Cell: ContentDateCell,
      ...fixedColumnStyle(180),
    },
  ];

  const rowClassNameFn = (row) => {
    const hashId = window.location.hash;
    if (hashId) {
      const scrollToId = hashId.substring(1);
      const {id} = row.original;
      return scrollToId === id ? 'row-highlighted' : null;
    } else {
      return null;
    }
  };

  return (
    <SimpleTable
      columns={columns}
      data={filter(associations, (a) => !onlyCurrent || !a.removed)}
      rowClassNameFn={rowClassNameFn}
      initialState={({
        sortBy: [{id: 'relatedChemicals'}, {id: 'relatedGenes'}],
      })}
    />
  );
}

function SummaryCell({row, value}) {
  return (
    <div>
      <RecommendationAnnotationTags {...row.original} parentCls={row.original.objCls} />
      <HtmlContainer html={value.html} inline={true} />
    </div>
  );
}

function ContentDateCell({row, value}) {
  let tag;
  if (row.original.removed) {
    tag = <Tag className="tag--sm tag--retired">Removed</Tag>;
  }
  return (
    <span>
      {value}
      {tag}
    </span>
  );
}

function PgxChemicalsCell({row, value}) {
  useEffect(() => {
    try {
      const hashId = window.location.hash;
      if (hashId) {
        const annId = hashId.substring(1);
        const targetElement = document.getElementById(annId);
        if (targetElement) {
          targetElement.scrollIntoView();
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-undef
      App.log.info(`Using a bad query selector ${window.location.hash}`);
    }
  }, []);

  return (
    <div id={row.original.id}>
      {AccIdCell({value})}
    </div>
  );
}
